<template>
  <!-- <div v-if="Object.keys(this.tableData).length > 0">-->
  <div v-if="this.mdetailShow">
    <v-layout row justify-space-between align-start class="inner">
      <v-flex sm12 md5 d-flex flex-wrap justify-space-between align-center>
        <h2 class="mt-1">Total: {{ totalSelectedProducts }}</h2>
      </v-flex>
      <v-flex sm12 md7 d-flex flex-wrap justify-space-between align-baseline>
        <v-switch
          v-model="isUnlink"
          color="error"
          class="clients_switch"
          hide-details
          style="transform: rotate(90deg)"
          @change="switchLinkClients"
        ></v-switch>
        <v-combobox
          v-model="linkClients"
          chips
          clearable
          multiple
          solo
          :items="dataOfClients"
          :label="isUnlink ? 'Unlink from client' : 'Link to client'"
          id="clients"
          item-text="text"
          item-value="value"
          class="custom_combobox mt-1"
          background-color="rgba(48, 127, 255, 0.1)"
        >
          <template v-slot:selection="data">
            <v-chip
              v-on="data.on"
              v-model="data.item.isLink"
              v-bind="data.attrs"
              close
              :input-value="data.selected"
              @click:close="remove(data.item.value)"
            >
              <strong>{{ data.item.text }}</strong>
            </v-chip>
          </template>
        </v-combobox>
        <v-btn
          text
          :ripple="false"
          :disabled="!linkClients.length"
          class="ex-btn ex-primary-btn custom_button mt-1"
          @click="linkDialog = true"
        >
          apply
        </v-btn>
        <v-btn
          :disabled="!linkClients.length"
          class="ex-btn ex-primary-btn custom_button mt-1"
          @click="selectProductClient"
          v-if="returnNewProduct"
        >
          Client for new product
        </v-btn>
      </v-flex>

      <v-dialog v-model="linkDialog" persistent max-width="400">
        <v-card>
          <v-card-title class="headline">
            {{
              isUnlink ? "Unlinking, are you sure?" : "Linking, are you sure ?"
            }}
          </v-card-title>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              text
              :ripple="false"
              :loading="loading"
              class="ex-btn ex-primary-btn text--white"
              @click="linkDialog = false"
            >
              No
            </v-btn>
            <v-btn
              text
              :ripple="false"
              :loading="loading"
              class="ex-btn ex-primary-btn text--white"
              @click="linkOrUnlinkToClients"
            >
              Yes
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>
  </div>
</template>

<script>
/* eslint-disable */
export default {
  name: "ProductDetailsHeader",
  props: {
    dataOfClients: {
      type: [Object, Array],
      default: null,
    },
    totalSelectedProducts: {
      type: Number,
      default: 0,
    },
    chosenProducts: {
      type: Array,
      default: null,
    },
  },
  data: () => ({
    isUnlink: false,
    linkClients: [],
    linkDialog: false,
    loading: false,
  }),
  methods: {
    selectProductClient() {
      this.$store.commit("productModule/ADD_PRODUCT_CLIENT", this.linkClients);
      this.linkClients = [];
    },

    notify(title, message) {
      this.$notify({
        group: "save",
        title,
        text: message,
        duration: 500,
        speed: 600,
      });
    },
    linkOrUnlinkToClients() {
      this.loading = true;
      this.linkDialog = false;
      const data = {
        task: this.isUnlink ? "unlinkFromClients" : "linkToClients",
        payload: {
          product_ids: this.chosenProducts,
          clients: this.linkClients.map((client) => client.value),
        },
      };
      this.$store
        .dispatch("productModule/linkOrUnlinkOfProductList", data)
        .then((res) => {
          console.log("LinkOfProductList", res);
          if (res.data.message === "error") {
            throw res.data.type;
          }
          this.linkClients = [];
          this.$emit("updateSelectedProduct");
          this.loading = false;
          this.notify("Link to client", "Client saved!");
        })
        .catch((error) => this.notify("Error", error));
    },
    remove(id) {
      this.linkClients = this.linkClients.filter(
        (client) => client.value !== id
      );
    },
    switchLinkClients() {
      if (this.isUnlink) {
        this.$store.commit("productModule/ADD_PRODUCT_CLIENT", []);
      } else {
        this.$store.commit(
          "productModule/ADD_PRODUCT_CLIENT",
          this.linkClients
        );
      }
      const message = this.isUnlink ? "Unlink from client" : "Link to client";
      this.notify("", message);
    },
    changeDefaultColorSwitch() {
      const switchBlocks = document.querySelectorAll(
        ".clients_switch .v-input--selection-controls__input div"
      );
      switchBlocks.forEach((block) => {
        block.style.color = "#42A5F5";
      });
    },
  },
  computed: {
    tableData() {
      return this.$store.state.productModule.urlsContainer;
    },
    mdetailShow() {
      return this.$store.state.productModule.DetailsShow;
    },

    returnNewProduct() {
      return this.$store.state.productModule.newProductShow;
    },
  },
  mounted() {
    this.changeDefaultColorSwitch();
    this.linkClients = [];
  },
  destroyed() {
    this.linkClients = [];
  },
};
</script>

<style scoped>
.custom_button {
  height: 48px !important;
}

.custom_combobox {
  max-width: 85%;
}

.clients_switch {
  height: 24px;
  width: 30px;
  margin-top: 0;
  padding-top: 0;
  transform: rotate(90deg);
}

.clients_switch .v-input--selection-controls__input div {
  color: red !important;
}

@media (max-width: 1440px) {
  .custom_combobox {
    max-width: 75%;
  }
}

@media (max-width: 1200px) {
  .custom_combobox {
    max-width: 70%;
  }
}

@media (max-width: 696px) {
  .custom_combobox {
    max-width: 65%;
  }
}

@media (max-width: 596px) {
  .custom_button {
    min-width: unset !important;
    width: unset !important;
    height: unset !important;
    padding: 14px 16px !important;
    font-size: 11px !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/product/ProductDetailsHeader.vue